import { icon, node } from "~/util/dom";
import Content from "./content";
import { _ } from "~/i18n";

export default class Inactive extends Content {
	_build() {
		this._dom.container.classList.add("content-inactive");

		if (this._options.inactive || this._options.temporarilyClosed) {
			this._dom.container.appendChild(icon("warn"));
			this._dom.container.appendChild(node("span", { className: "title", textContent: _(this._options.temporarilyClosed ? "detail.content.closed.temporarilyClosed" : "detail.content.closed.title") }));
		}
	}
}
